import { render, staticRenderFns } from "./BillStorageDialog.vue?vue&type=template&id=1265ccf9&scoped=true&"
import script from "./BillStorageDialog.vue?vue&type=script&lang=js&"
export * from "./BillStorageDialog.vue?vue&type=script&lang=js&"
import style0 from "./BillStorageDialog.vue?vue&type=style&index=0&id=1265ccf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265ccf9",
  null
  
)

export default component.exports